import { formatNumericValue } from 'utils/numbers'
import { StatusDot } from './Tps'
import { rpcAlertThreshold, rpcWarningThreshold } from './Status'
import { useTranslation } from 'next-i18next'

const RpcPing = ({ rpcPing }: { rpcPing: number }) => {
  const { t } = useTranslation('status-bar')
  return (
    <div>
      <div className="flex items-center">
        <StatusDot
          status={rpcPing ? rpcPing : 1000}
          alert={rpcAlertThreshold}
          warning={rpcWarningThreshold}
        />
        <span className="font-mono text-xs text-th-fgd-2">
          <span className="mr-1">{formatNumericValue(rpcPing, 0)}</span>
          <span className="font-normal text-th-fgd-4">{t('units.ms')}</span>
        </span>
      </div>
    </div>
  )
}

export default RpcPing
